// extracted by mini-css-extract-plugin
export default {"dashboard-container":"AdminLocalkassaBalance_dashboard-container__xwiKr","dashboard-title":"AdminLocalkassaBalance_dashboard-title__humGp"};